import angular from "angular";
import { Chart, registerables, ChartConfiguration, ChartType, ScatterDataPoint, BubbleDataPoint } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import "chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm";
/** Register chart registerables (ex. tooltip) */
Chart.register(...registerables, annotationPlugin);

/**
 Controller rendering chart by provided config
 */
export class ChartController implements angular.IController {
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["$element", "$timeout", "$scope"];

  /** Configuration of chart */
  public config: ChartConfiguration<ChartType, number[] | ScatterDataPoint[] | BubbleDataPoint[], unknown>;
  private chart: Chart = undefined;
  /** Custom height of chart */
  public customHeight: string;
  /** Custom width of chart */
  public customWidth: string;
  /** Custom class of chart */
  public customClass: string;
  constructor(
    private $element: JQLite,
    private $timeout: angular.ITimeoutService,
    private $scope: angular.IScope,
  ) {}

    /**
     * Implement IController
     */
    public init() {
      this.customHeight = this.customHeight ?? "";
      this.customWidth = this.customWidth ?? "";
      this.customClass = this.customClass ?? "";
      this.$timeout(() => {
        this.createChart();
      });
      this.$scope.$watch(() => this.config?.data, (newValue) => {
        if (newValue) {
          this.updateChart();
        }
      }, true);
    }

      /** Creates chart based on data and options to canvas or updates chart if it already exists */
  public createChart(): void {
    if (!this.chart) {
      const ctx = (this.$element.find("canvas")[0] as HTMLCanvasElement)?.getContext("2d");
      if (ctx && this.config) {
        this.chart = new Chart(ctx, this.config);
      }
    }
  }

  /**
   * Updates provided current chart
   * "none" parameters means no animation for update
   */
  public updateChart(): void {
    if(this.chart) {
      this.chart.data = this.config?.data;
      this.chart.update("none");
    }
  }
}
